import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpBaseService } from 'src/app/services/http-base.service';
import { environment } from 'src/environments/environment';
import { Reestructura } from '../modelos/reestructura.model';

const API_URL = environment.apiUrl;
const SUBMODULO = 'reestructura';

@Injectable({
  providedIn: 'root'
})
export class ReestructuraService extends HttpBaseService<Reestructura>{

    constructor( private http: HttpClient ) { 
        super(http,SUBMODULO);
    }
    //Obtener Reestructura por id
    obtenerReestructuraPorId(id: number){
        return this.http.get<Reestructura>(API_URL + SUBMODULO +"/getById/"+ id);
    }
  
}